var $name="analytics/contact",$path="app/modules/analytics/contact.js",$this={$name,$path,};import getSlugs from 'app/utilities/getSlugs';
import lookupSlugs from 'app/utilities/lookupSlugs';

/**
 * @param {
 * {
 * contactCategory: string,
 * requestTypeURL: string,
 * formId: string,
 * userHashedEmail: string,
 * formObj: Object,
 * }
 * } variables
 * @returns
 */
const formTypes = {
  ContactUsbFO: 'ContactUsbFO',
  FooterSubscription: 'FooterSubscription',
};
const fromCategory = {
  web2Sales: 'Web2Sales',
  web2Newsletter: 'Web2Newsletter',
};
const contactSubmitProvider = ({
  requestTypeURL,
  formId,
  userHashedEmail,
  formObj = {},
}, config) => {
  const { pathname } = new URL(requestTypeURL, window.location.href);
  const formType = lookupSlugs(
    config.requestType ?? {},
    getSlugs(pathname),
    pathname,
  );

  const formParams = {};

  if (formId?.includes(formTypes.ContactUsbFO)) {
    formParams.formCategory = fromCategory.web2Sales;
    formParams.userHashedEmail = userHashedEmail;
    formParams.formCompany = formObj.Company || formObj.company;
    formParams.formLocation = formObj.Country || formObj.country || formObj.Location || formObj.location;
    formParams.formIam = formObj.iama || formObj.Iama;
    formParams.contactCategory = fromCategory.web2Sales;
  } else if (formId?.includes(formTypes.FooterSubscription)) {
    formParams.formCategory = fromCategory.web2Newsletter;
    formParams.userHashedEmail = userHashedEmail;
    formParams.formIam = formObj.iama || formObj.Iama;
    formParams.contactCategory = fromCategory.web2Newsletter;
  }

  return {
    contactCategory: formType,
    ...formParams,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { contactSubmitProvider };
